import { Component, inject, Input } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { NgxPermissionsService } from 'ngx-permissions';
import { StorageService } from 'src/app/services/storage-service.service';
import { MenuItem } from 'src/app/shared/interfaces/data.interfaces';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-home-sidebar',
  templateUrl: './home-sidebar.component.html',
  styleUrls: ['./home-sidebar.component.scss'],
  standalone: false,
})
export class HomeSidebarComponent {
  permissionService = inject(NgxPermissionsService);
  storageService = inject(StorageService);
  router = inject(Router);

  @Input() sidebarMenu: MenuItem[];
  @Input() moduleTitle: string;
  @Input() moduleIconType: string;
  @Input() moduleIconTitle: string;

  menuData: MenuItem[];

  userPermissions = this.permissionService.getPermissions();

  ngOnInit(): void {
    this.menuData = this.sidebarMenu;
  }

  isActiveRoute(children: MenuItem[]) {
    return children?.findIndex(d => d?.route === this.router?.url) > -1;
  }

  getChildrenPermission(children: MenuItem[]): boolean {
    const permissionsExist: any = [];
    children?.forEach(c => permissionsExist.push(...c?.permissions));
    return this.has(Object.keys(this.userPermissions), permissionsExist);
  }

  protected has(arr: string[], valuesToCheck: string[]): boolean {
    for (const value of valuesToCheck) {
      if (arr.includes(value)) {
        return true;
      }
    }
    return false;
  }
}
